import { useEffect, useState } from 'react';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const useRecaptcha = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Vérifie si reCAPTCHA est déjà disponible
    if (window.grecaptcha && window.grecaptcha.ready) {
      window.grecaptcha.ready(() => {
        setIsLoaded(true);
        setIsReady(true);
      });
      return;
    }

    // Vérifie si le script est déjà en cours de chargement
    const existingScript = document.querySelector(`script[src*="google.com/recaptcha/api.js"]`);
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        if (window.grecaptcha && window.grecaptcha.ready) {
          window.grecaptcha.ready(() => {
            setIsLoaded(true);
            setIsReady(true);
          });
        }
      });
      return;
    }

      // Crée un élément script
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
    
    // Gère le chargement du script
    script.onload = () => {
      setIsLoaded(true);
      if (window.grecaptcha && window.grecaptcha.ready) {
        window.grecaptcha.ready(() => {
          setIsReady(true);
        });
      }
    };

    script.onerror = () => {
      console.error('Erreur lors du chargement de reCAPTCHA');
      setIsLoaded(false);
      setIsReady(false);
    };
      
      // Ajoute le script au document
      document.head.appendChild(script);

      return () => {
      // Nettoie le script lors du démontage du composant seulement s'il n'y a pas d'autres instances
      const scriptCount = document.querySelectorAll(`script[src*="google.com/recaptcha/api.js"]`).length;
      if (scriptCount === 1 && document.head.contains(script)) {
        document.head.removeChild(script);
      }
      };
  }, []);

  return { isLoaded, isReady };
}; 